import { API_TYPE, fetchData } from '@umu/umu-fetch';

export type ShieldSaveServiceParams = {
    obj_id: string | number;
    obj_type: string;
}

export type ShieldSaveServiceData = {
    status: any;
}

export const shieldSaveService = (data: ShieldSaveServiceParams): Promise<IResponse<ShieldSaveServiceData>> => {
    return fetchData({
        type: API_TYPE.POST,
        url: "/uapi/v1/violation/shield-save"
    }, data).then((res: IResponse<ShieldSaveServiceData>) => {
        return res;
    });
};

export type CanReportParams = {
    obj_id: string;
    obj_type: string;
};

export const canReportService = async (params: CanReportParams) => {
    return fetchData({ url: '/uapi/v1/violation/can-report', type: API_TYPE.GET }, params).then((res: any) => {
        return res;
    });
};
